<template>
  <el-form ref="postForm" :rules="rules" :model="postForm">
    <el-form-item label="优豆" prop="point">
      <el-input-number v-model="postForm.point" :min="-10000" :max="10000" label="描述文字" />
    </el-form-item>
    <el-form-item label="原因" prop="remark">
      <el-input v-model="postForm.remark" type="textarea" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" class="fn-right" @click="fnHandleSave">保存 </el-button>
    </el-form-item>

  </el-form>
</template>
<script>

const defaultForm = {
  master_id: '',
  point: 1,
  remark: ''

}
import { validateRequire } from '@/utils/validate'

export default {
  name: 'AddFood',
  components: {

  },
  props: {
    masterId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm),
      remarkLists: [],
      rules: {
        point: [{ validator: validateRequire, trigger: 'manual', message: '优豆' }],
        remark: [{ validator: validateRequire, trigger: 'manual', message: '原因' }]
      }
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    fnHandleSave: function() {
      this.postForm.master_id = this.masterId
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.updatePoint(this.postForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
            }
            this.$emit('successCBK')
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scope>

.combo-group {
  .tuolele-main-search {
    .el-button {
      margin-left:0px!important
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .el-form-item__content {
      margin: 0 20px 0 12px;
    }
  }
}
</style>
